import MinimalCarousel from "../components/common/sections/MinimalCarousel";
import ImageListSection from '../components/common/sections/ImageListSection';
import FeatureSection from '../components/common/sections/FeatureSection';
import HeroSection from "../components/common/sections/HeroSection";
import CtaSection from "../components/common/sections/cta/CtaSection";

const Home = ({t}) => {
    const carousel_data = [
      { image: '/images/carousel_home/coworking2_carousel.jpg', caption: t("pages.home.texts.text1") },
      { image: '/images/carousel_home/coworking1_carousel.jpg', caption: t("pages.home.texts.text1") },
     ];
    
     const services = t("pages.services", { returnObjects: true });
     const services_title = services.title;
     const services_options = services.options;
     const services_items = Object.keys(services_options).map((key) => {
         const { title, homeEmoji, hideInHome } = services_options[key];
         if (hideInHome) return null;
         return homeEmoji + ' ' + title
     });

     const feature_section_booking = t("pages.home.feature_section_booking", { returnObjects: true });
     const feature_section_rates = updateFeatureSectionRates(t("pages.rates", { returnObjects: true }), t("pages.home.feature_section_rates", { returnObjects: true }));
     const feature_section_booking_overview = t("pages.home.feature_section_booking_overview", { returnObjects: true });
     const services_items_desktop = getServicesItems(t("pages.services", { returnObjects: true }));


    return (
      <div className="content">
        <MinimalCarousel  data={carousel_data} width="100%" height="700px"/>
        {/* <h1 className="content-h1">{t("pages.home.texts.text1")}</h1> */}

        <div className="desktop">
          <FeatureSection
            title={t("pages.home.split_section.split_section1.text")}
            items={services_items_desktop}
            buttonText={feature_section_booking.button}
            buttonLink="/bookings"
            buttonTarget={"booking-form"}
            image="/images/gallery/photo9.jpg"
            imagePosition='left'
            enableLightbox={true}
          />
          <HeroSection
            title={""}
            shortTitle={""}
            color="black"
            text={feature_section_rates.title}
            buttonText={feature_section_rates.button}
            buttonLink="/rates"
            image="/images/gallery/photo17.jpg"
            verticalAlign="bottom"
            horizontalAlign="left"
          />
          <FeatureSection
            title={feature_section_booking_overview.title_short}
            items={feature_section_booking_overview.items}
            buttonText={feature_section_booking_overview.button}
            buttonLink="/bookings"
            buttonTarget={"booking-overview-form"}
            image="/images/gallery/photo13.jpg"
            imagePosition='left'
            enableLightbox={true}
          />
        </div>

        <div className="mobile">
          <ImageListSection title={services_title} items={services_items} image="/images/gallery/photo15.jpg" imageSide="right"/>
          <div className="generic-separator" />
          <CtaSection 
            title={t("pages.home.split_section.split_section1.text")} 
            buttonText={feature_section_booking.button} 
            buttonLink="/bookings"
            image="/images/gallery/photo9.jpg"
          />
          <CtaSection 
            title={feature_section_rates.title} 
            buttonText={feature_section_rates.button}
            buttonLink="/rates"
            image="/images/gallery/photo17.jpg"
          />
          <CtaSection 
            title={feature_section_booking_overview.title_short} 
            buttonText={feature_section_booking_overview.button}
            buttonLink="/bookings"
            buttonTarget={"booking-overview-form"}
            image="/images/gallery/photo13.jpg"
          />
        </div>
      </div>
    )
  };

  export default Home;

  const getServicesItems = (services) => {
    const servicesOptions = services.options || {};
    const paragraphs = Object.keys(servicesOptions)
      .filter((key) => !servicesOptions[key].hideInHome)
      .map((key) => {
        const { title, homeEmoji } = servicesOptions[key];
        return `${homeEmoji} ${title}`;
      });
  
    return [
      {
        subtitle: services.title,
        paragraphs
      }
    ];
  };

  const updateFeatureSectionRates = (rates, feature) => { 
    const ratesOptions = rates.options || {};
    const offers = [];
  
    Object.keys(ratesOptions).forEach((key) => {
      const option = ratesOptions[key];
      if (option.duration) offers.push(`🔹 ${option.duration}`);
    });
  
    // Replace the paragraphs of the first item if it's empty
    if (
      feature &&
      Array.isArray(feature.items) &&
      feature.items[0] &&
      Array.isArray(feature.items[0].paragraphs) &&
      feature.items[0].paragraphs.length === 0
    ) {
      feature.items[0].paragraphs = offers;
    }
  
    return feature;
  }; 